import { useGetDaasEntities } from '../useGetDaasEntities';

export const useGetDaasApplicationSets = (
  userOwedApplicationSets: boolean = false,
  userInSecurityGroup: boolean = false,
) => {
  return useGetDaasEntities(
    'daas-application-set',
    userOwedApplicationSets,
    userInSecurityGroup,
  );
};
